var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuestionOutlined = function SvgQuestionOutlined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 18,
      height: 18,
      viewBox: "0 0 18 18",
      fill: "#041F47",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M9 16.5C13.1333 16.5 16.5 13.1333 16.5 9C16.5 4.86675 13.1333 1.5 9 1.5C4.86675 1.5 1.5 4.86675 1.5 9C1.5 13.1333 4.86675 16.5 9 16.5ZM9 15C5.67741 15 3 12.3226 3 9C3 5.67741 5.67741 3 9 3C12.3226 3 15 5.67741 15 9C15 12.3226 12.3226 15 9 15Z"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8.43 10.2795H9.879C9.879 9.3555 11.643 8.8935 11.643 7.3185C11.643 5.964 10.4775 5.25 9.291 5.25C8.178 5.25 7.1805 5.817 6.75 6.8775L7.989 7.5915C8.2095 7.0245 8.619 6.657 9.2385 6.657C9.8475 6.657 10.194 6.9405 10.194 7.4235C10.194 8.463 8.43 8.8935 8.43 10.2795ZM9.1545 12.8835C9.648 12.8835 10.047 12.4845 10.047 11.991C10.047 11.4975 9.648 11.0985 9.1545 11.0985C8.661 11.0985 8.262 11.4975 8.262 11.991C8.262 12.4845 8.661 12.8835 9.1545 12.8835Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgQuestionOutlined, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/question-outlined.d3f7c2c9.svg";
export { ForwardRef as ReactComponent };